import { api, prefix } from "@/api";
import { LoggedUserNetworkType } from "@/types/network";
import { NetworkMemberProfileType } from "@/types/profile";
import type { AxiosRequestConfig } from "axios";

const namespace = "platform";

export const getNetworkListById = (
  userId: number | string,
  applicationId: number | string,
  config: AxiosRequestConfig = {}
) => {
  return api<Array<any>>({
    url: `${prefix}/${namespace}/profile/networks/${userId}?applicationId=${applicationId}`,
    method: "get",
    ...config,
  });
};

export const getLoggedUserNetworks = (config: AxiosRequestConfig = {}) => {
  return api<{ data: Array<LoggedUserNetworkType> }>({
    url: `${prefix}/gaia/profile/networks`, // ?complete=true al momento hardcoded perchè stato detto così da backend
    method: "get",
    ...config,
  });
};

export const getAssigneeNetworks = (
  userId: number | string,
  roleId: number,
  config: AxiosRequestConfig = {}
) => {
  return api<{ data: Array<LoggedUserNetworkType> }>({
    url: `${prefix}/gaia/profile/networks/${userId}/role/${roleId}`,
    method: "get",
    ...config,
  });
};

export const getUsesOfNetwork = (
  networkId: number | string,
  config: AxiosRequestConfig = {}) => {
  // Il backend risponde con un array nudo e l'interceptor `onResponseExtractData`
  // restituisce già il body: la promise risolve con l'array, non con un AxiosResponse
  return api<Array<NetworkMemberProfileType>>({
    url: `${prefix}/profile/v2/network/profile?network_ids=${networkId}`, // ?complete=true al momento hardcoded perchè stato detto così da backend
    method: "get",
    ...config,
  }) as unknown as Promise<Array<NetworkMemberProfileType>>;
};